import { Component, OnInit, ViewChild, TemplateRef, Input } from '@angular/core';
import { EpbtFaCompetitorService } from '../../services/epbt-fa-competitor.service';
import { IEpGridModel, EpEventService, IEpGridSelectionOptions, EpGridEvent, IEpComponentEventArg } from '@epicor/kinetic';
import { BistrackConfig, CustomEvents } from 'ep-bt-controls';
import { FieldAgentClient } from 'ep-bt-field-agent-proxy';
import { Router } from '@angular/router';
declare var $: any;
import { EpbtFaProductService } from '../../services/epbt-fa-product.service';
import { EpbtFieldAgentService } from '../../services/epbt-field-agent.service';


@Component({
  // tslint:disable-next-line:component-selector
  selector: 'epbt-fa-competitor-selected-product-grid',
  templateUrl: './epbt-fa-competitor-selected-product-grid.component.html',
  styleUrls: ['./epbt-fa-competitor-selected-product-grid.component.scss']
})
export class EpbtFaCompetitorSelectedProductGridComponent implements OnInit {

  products: any;
  public gridModel: IEpGridModel;
  data: any;
  @Input() deleteFlag = false;
  bistrackSettings: any;
  currency: string;
  public pageSize: number;

  @ViewChild('currencyTemplate', {static: true}) currencyTemplate: TemplateRef<any>;
  @ViewChild('decimalTemplate', {static: true}) decimalTemplate: TemplateRef<any>;
  @ViewChild('removeTemplate', {static: true}) removeTemplate: TemplateRef<any>;


  constructor(
    private faService: EpbtFieldAgentService,
    private productService: EpbtFaProductService,
    private router: Router,
    private epbtFaCompetitorService: EpbtFaCompetitorService,
    public epEvent: EpEventService) { }

  ngOnInit() {

    console.log(this.epbtFaCompetitorService.competitorPricing, 'competitor pricing data');
    this.faService.getBisTrackSetting((bistrackSettings: any) => {
      this.bistrackSettings = bistrackSettings;
      this.currency = this.bistrackSettings.baseCurrency.symbol;
      this.pageSize = this.bistrackSettings.searchPageSize;

    });


    this.gridModel = this.getGridModel();
    if (this.epbtFaCompetitorService.competitorPricing.Lines.length > 0) {
      this.gridModel.data = this.epbtFaCompetitorService.competitorPricing.Lines;
    }

    //  this.data = this.epbtFaCompetitorService.competitorPricing.Lines;

    // this.gri dModel.data = this.epbtFaCompetitorService.finalCompetitorObj.slice();
  }


  // GRID START
  getGridModel(): IEpGridModel {
    const selectionOptions: IEpGridSelectionOptions = {
      selectByField: 'productId',
      selectedKeys: [],
    };
    const model: IEpGridModel = {
      resizable: false,
      reorderable: false,
      groupable: false,
      filterable: false,
      scrollable: 'scrollable',
      rowHeight: 20,
      height: this.getHeight(),
      sortable: true,
      selectionOptions: selectionOptions,
      columns: [
        { field: 'ourProduct.productCode', title: 'CODE', width: 30, hidden: false },
        { field: 'ourProduct.description', title: 'DESCRIPTION', width: 30, hidden: false },
        { field: 'ourProduct.standardSellPrice', title: 'PRICE', width: 30, hidden: false, cellTemplate: this.currencyTemplate },
        { field: 'ourSellPer.name', title: 'UOM', width: 30, hidden: false },
        { field: 'competitorSellPrice', title: 'COMP', width: 30, hidden: false, cellTemplate: this.decimalTemplate },
        { field: 'competitorSellPer.name', title: 'UOM', width: 30, hidden: false },
        { title: 'DELETE', width: 30, hidden: false, class: 'ep-color-red', cellTemplate: this.removeTemplate }
      ],
      epOnComponentEvent: (eventArg: IEpComponentEventArg) => {
        if (eventArg.eventId == 'epOnCellClick' && eventArg.event && eventArg.event.type == 'click') {
          if (eventArg.event.column.displayTitle != 'DELETE') {
            this.navigateTo(eventArg.event.dataItem);
          }

          // if (eventArg.event.column.displayTitle != 'DELETE') {
          //   //this.epEvent.broadcast(CustomEvents.BinLocationSummaryClick, 1);
          //   this.epbtFaCompetitorService.isNegotiationEdit = true;
          //   // this.productService.selectedProductItem = this.epbtFaCompetitorService.selectedProductsForBinding.find(c => c.product.productId == eventArg.event.dataItem.product.productId).product;
          //   this.router.navigate(['/home/product/details', eventArg.event.dataItem.product.productId]);
          // }
        }
      }

      // fnEvent: (event: EpGridEvent, args: any) => {
      //   if (event === EpGridEvent.cellClick && args.column.displayTitle != 'DELETE') {
      //     //this.epEvent.broadcast(CustomEvents.BinLocationSummaryClick, 1);
      //     this.epbtFaCompetitorService.isNegotiationEdit = true;
      //     this.productService.selectedProductItem = this.epbtFaCompetitorService.selectedProductsForBinding.find(c => c.product.productId == args.dataItem.product.productId).product;
      //     this.router.navigate(['/home/product/details', args.dataItem.product.productId]);
      //   }

    };
    $(window).resize(() => {
      this.updateGrid();
    });
    return model;
  }

  // GRID END

  // grid height calculation start
  updateGrid() {
    const calHeight = this.getHeight();
    this.gridModel.height = calHeight;
  }


  getHeight(): number {
    const height = $(window).outerHeight() - 350; // 593
    const width = parseInt($('body').width());

    if (width > 250 && width < 1023) {
      // mobile and ipad
      return 400;
    }
    return height;

  }
  // getHeight(): number {
  //   var height = parseInt($('body').height());

  //   if (height > 900) {
  //     //return 300;
  //     return 600;
  //   }
  //   else return 400;//return 500;
  // }
  // grid height calculation end

  updateGridData(flag: boolean) {
    // this.gridModel.data = this.epbtFaCompetitorService.finalCompetitorObj;
  }

  // navigateToDetailsView(args) {
  //   this.epbtFaCompetitorService.isReCall = true;
  //   this.epbtFaCompetitorService.finalCompetitorObj = args;
  //   this.router.navigate(['/home/product/details', args.productId]);
  // }

  navigateTo(args: any) {
    this.epbtFaCompetitorService.isNegotiationEdit = true;
    this.epbtFaCompetitorService.competitorPricingLine = args;
    this.router.navigate(['/home/product/details', args.ourProduct.productId]);
  }


  onCardClick(product) {
    this.navigateTo(product);
    // this.epbtFaCompetitorService.isNegotiationEdit = true;
    // this.productService.selectedProductItem = this.epbtFaCompetitorService.selectedProductsForBinding.find(c => c.product.productId == product.productId);
    // this.router.navigate(['/home/product/details', product.productId]);
  }

  onRemove(dataItem: any) {
    const index = this.epbtFaCompetitorService.competitorPricing.Lines.findIndex(c => c.lineNumber == dataItem.lineNumber);
    // if (index >= 0) {
    //   this.epbtFaCompetitorService.competitorPricing.Lines.splice(index, 1);
    //   this.gridModel.data = this.epbtFaCompetitorService.competitorPricing.Lines.slice();
    // }
    if (index >= 0) {
      let lineNum = 0;
      this.epbtFaCompetitorService.competitorPricing.Lines.splice(index, 1);
      this.epbtFaCompetitorService.competitorPricing.Lines.forEach(item => item.lineNumber = ++lineNum);
      this.gridModel.data = this.epbtFaCompetitorService.competitorPricing.Lines.slice();
    }


  }
}
